<template>
    <div
        class="cookie-consent"
        v-if="this.open"
    >
        <div class="cookie-consent-content">
            {{content}}
        </div>
        <button
            class="cookie-consent-btn"
            @click="open = false"
        >
            {{ buttonText}}
        </button>
    </div>
</template>
<script>
export default {
    props: {
        content: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            required: false,
            default: 'OK'
        }
    },
    data() {
        return {
            open: false
        }
    },
    created() {
        if(!localStorage.getItem('cookie.consent.viewed')) {
            this.open = true;
            localStorage.setItem('cookie.consent.viewed', true);
        }

    }
}
</script>
